import { getLocalizedAssetUrl } from './utilities.js';

describe('getLocalizedAssetUrl', () => {
  const basePath = 'https://cdn.example.com/assets';

  beforeEach(() => {
    global.fetch = jest.fn();
  });

  afterEach(() => {
    jest.resetAllMocks();
  });

  test('returns exact locale match if available', async () => {
    fetch.mockResolvedValueOnce({ ok: true });

    const url = await getLocalizedAssetUrl('en-CA', 'onboarding', 'mp4', basePath);
    expect(url).toBe(`${basePath}/onboarding/en-ca.mp4`);
  });

  test('falls back to ISO code if BCP 47 variant not found', async () => {
    fetch
      .mockResolvedValueOnce({ ok: false }) // BCP 47 variant not found
      .mockResolvedValueOnce({ ok: true }); // ISO 639 variant found

    const url = await getLocalizedAssetUrl('fr-CA', 'onboarding', 'mp4', basePath);
    expect(url).toBe(`${basePath}/onboarding/fr.mp4`);
  });

  test('falls back to English if no other match found', async () => {
    fetch
      .mockResolvedValueOnce({ ok: false }) // BCP 47 variant not found
      .mockResolvedValueOnce({ ok: false }) // ISO 639 variant not found
      .mockResolvedValueOnce({ ok: true }); // English variant found

    const url = await getLocalizedAssetUrl('es-MX', 'onboarding', 'mp4', basePath);
    expect(url).toBe(`${basePath}/onboarding/en.mp4`);
  });

  test('returns null and logs error if no asset is reachable', async () => {
    fetch
      .mockResolvedValueOnce({ ok: false }) // BCP 47 variant not found
      .mockResolvedValueOnce({ ok: false }) // ISO 639 variant not found
      .mockResolvedValueOnce({ ok: false }); // English variant not found

    const url = await getLocalizedAssetUrl('ja', 'onboarding', 'mp4', basePath);
    expect(url).toBe(undefined);
  });

  test('handles fetch network errors and continues fallback', async () => {
    fetch
      .mockRejectedValueOnce(new Error('network')) // BCP 47 variant fetch fails
      .mockResolvedValueOnce({ ok: true }); // ISO 639 variant found

    const url = await getLocalizedAssetUrl('de-DE', 'onboarding', 'mp4', basePath);
    expect(url).toBe(`${basePath}/onboarding/de.mp4`);
  });
});
